// extracted by mini-css-extract-plugin
export default {"Form":"Y_tdx54DmWz8bWjrFD7r","ButtonsContainer":"R88v50mE1l3V8IazjxTa"};